import React, { useState } from "react";
import InputMask from "react-input-mask";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Alert,
  InputGroup,
  InputGroupText,
  InputGroupAddon
} from "reactstrap";
import { Enviroments } from "../enviroments/enviroments";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [cpf, setCpf] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [birthday, setBirthday] = useState(""); // Preenchido automaticamente
  const [errorMessages, setErrorMessages] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();

  const handleCpfBlur = async () => {
    if (!cpf) {
      setErrorMessages(["CPF não pode estar vazio!"]);
      return;
    }

    try {
      const payload = {
        birthday: "",
        document: cpf,
        email: "",
        email_confirmation: "",
        name: "",
        password: "",
        password_confirmation: "",
        phone: ""
      };

      const response = await axios.post(
        `${Enviroments.API_URL_LOTOGREEN}api/validate/document`,
        payload
      );

      if (response.data?.name) {
        setName(response.data.name); // Preenche o campo "name" automaticamente
        setBirthday(response.data.birthday); // Preenche o campo "birthday" automaticamente
        setErrorMessages([]); // Limpa mensagens de erro se a validação for bem-sucedida
      } else {
        setErrorMessages(["Não foi possível validar o CPF."]);
      }
    } catch (err) {
      if (err.response?.data?.errors) {
        const backendErrors = Object.values(err.response.data.errors).flat();
        setErrorMessages(backendErrors);
      } else {
        setErrorMessages(["Erro ao validar CPF. Verifique e tente novamente."]);
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErrorMessages([]);

    if (
      !email ||
      !password ||
      !passwordConfirmation ||
      !cpf ||
      !name ||
      !phone
    ) {
      setErrorMessages(["Todos os campos devem ser preenchidos!"]);
      return;
    }

    if (password !== passwordConfirmation) {
      setErrorMessages(["As senhas não conferem!"]);
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        birthday,
        document: cpf,
        email,
        email_confirmation: email,
        name,
        password,
        password_confirmation: passwordConfirmation,
        phone,
        termsAccepted: true,
        referrer_id: 417048,
        btag: "nileeqmouinljnfomrgzzbfmi",
        token: null,
        afp: "teleco-app",
        afp2: "teleco-app"
      };

      const response = await axios.post(
        `https://lotogreen.bet.br/api/auth/register`,
        payload
      );

      const costumer = {
        name: name,
        email: email,
        password: password,
        phone: phone,
        role: "ROLE_APP",
        cpf: cpf,
        firstBalance: "1000"
      };

      if (response.status === 200 || response.status === 201) {
        alert("Cadastro realizado com sucesso.");
        history.push("/auth/login");

        const response2 = await axios.post(
          `${Enviroments.API_URL_IA}users`,
          costumer
        );
        // Redirecionar ou limpar os campos após o sucesso
      }
    } catch (err) {
      // Mapeia as mensagens de erro retornadas pelo backend
      if (err.response?.data?.errors) {
        const backendErrors = Object.values(err.response.data.errors).flat();
        setErrorMessages(backendErrors);
      } else {
        setErrorMessages([
          "Erro ao realizar o cadastro. Verifique os dados informados."
        ]);
      }
      console.log(JSON.stringify(err.response.data));
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <Col className="ml-auto mr-auto col-md-6 col-lg-4 register">
        <Card>
          <Form onSubmit={handleSubmit}>
            <CardHeader>
              <h4 className="text-center">Cadastro</h4>
            </CardHeader>
            <CardBody>
              {errorMessages.length > 0 && (
                <Alert color="danger">
                  <ul className="mb-0">
                    {errorMessages.map((msg, index) => (
                      <li key={index}>{msg}</li>
                    ))}
                  </ul>
                </Alert>
              )}
              <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  placeholder="Digite seu email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Senha</Label>
                <InputGroup>
                  <Input
                    type={showPassword ? "text" : "password"}
                    placeholder="Digite sua senha"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText
                      onClick={toggleShowPassword}
                      style={{ cursor: "pointer", backgroundColor: "black" }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label>Confirme a Senha</Label>
                <InputGroup>
                  <Input
                    type={showPassword ? "text" : "password"}
                    placeholder="Confirme sua senha"
                    value={passwordConfirmation}
                    onChange={e => setPasswordConfirmation(e.target.value)}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText
                      onClick={toggleShowPassword}
                      style={{ cursor: "pointer", backgroundColor: "black" }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label>CPF</Label>
                <InputMask
                  mask="999.999.999-99"
                  value={cpf}
                  onChange={e => setCpf(e.target.value)}
                  onBlur={handleCpfBlur} // Valida CPF ao sair do campo
                >
                  {() => <Input placeholder="Digite seu CPF" />}
                </InputMask>
              </FormGroup>
              <FormGroup>
                <Label>Nome</Label>
                <Input
                  type="text"
                  placeholder="Digite seu nome"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  disabled // Nome preenchido automaticamente
                />
              </FormGroup>
              <FormGroup>
                <Label>Telefone</Label>
                <InputMask
                  mask="(99) 99999-9999"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                >
                  {() => <Input placeholder="Digite seu telefone" />}
                </InputMask>
              </FormGroup>
            </CardBody>
            <CardFooter className="d-flex flex-column">
              <Button
                className="btn-fill"
                color="primary"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Cadastrando..." : "Criar Conta"}
              </Button>
              <a
                className="btn btn-outlined"
                href="https://wa.me/+5511971522258?text=Preciso de Ajuda (ref. cadastro)."
                target="_blank"
              >
                Falar com suporte
              </a>

              <Link to="/auth/login" className="mt-4 text-center">
                Já possuí cadastro ? Clique aqui
              </Link>
            </CardFooter>
          </Form>
        </Card>
      </Col>
    </div>
  );
}

export default Register;
